/* eslint-disable camelcase */
type Locale = 'en' | 'es';

type Phrase = (l: Locale) => string;

export const i18n_thank_you_for_being_part_of_yoga_international_family: Phrase = locale => {
  const en = `Thank you for being a part of the Yoga International family!`;
  const phrases: { [key: string]: undefined | string } = {
    en,
    es: `¡Gracias por ser parte de la familia de Yoga International!`,
  };
  return phrases[locale] || en;
};
